var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-icon',{staticClass:"mdi mdi-magnify search-icon"}),_c('input',{staticClass:"search-input",attrs:{"id":_vm.id,"placeholder":_vm.placeholder},domProps:{"value":_vm.searchValue},on:{"input":function($event){return _vm.handleSearch($event.target.value)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }